<template>
    <div>
        <!-- <hr /> -->
        <div class="footer">
            <div class="icon">
                <router-link :to="{ name: 'HomePage' }">
                    <svg width="18" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            :class="{ 'clicked-home': activeHome }"
                            d="M8.10776 16.5611V11.4963H12.1078V16.5611C12.1078 17.1182 12.5578 17.574 13.1078 17.574H16.1078C16.6578 17.574 17.1078 17.1182 17.1078 16.5611V9.47033H18.8078C19.2678 9.47033 19.4878 8.89294 19.1378 8.58905L10.7778 0.961431C10.3978 0.617023 9.81776 0.617023 9.43776 0.961431L1.07776 8.58905C0.737764 8.89294 0.947764 9.47033 1.40776 9.47033H3.10776V16.5611C3.10776 17.1182 3.55776 17.574 4.10776 17.574H7.10776C7.65776 17.574 8.10776 17.1182 8.10776 16.5611Z"
                            stroke="#CECEDA"
                            stroke-width="1.8"
                        />
                    </svg>
                </router-link>
            </div>
            <div class="icon">
                <router-link :to="{ name: 'Chatroom' }">
                    <svg
                        width="20"
                        height="18"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 22 18"
                        style="enable-background: new 0 0 22 18"
                        xml:space="preserve"
                    >
                        <path
                            :class="{ clicked: activeChatroom }"
                            class="st0"
                            d="M19,0.8H3c-1.1,0-2,0.9-2,2l0,12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2v-12C21,1.7,20.1,0.8,19,0.8z M19,13.8
                        c0,0.5-0.5,1-1,1H4c-0.5,0-1-0.5-1-1v-9l6.9,4.3c0.7,0.4,1.5,0.4,2.1,0L19,4.8V13.8z M11,7.8l-8-5h16L11,7.8z"
                            fill="#CECEDA"
                            stroke-width="0.1"
                        />
                    </svg>
                </router-link>
                <div v-if="unreadMessage" id="message_notification" class="flex-center" />
            </div>

            <div class="icon">
                <router-link :to="{ name: 'Intsearch' }">
                    <svg width="22" height="22" viewBox="0 0 21 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            :class="{ clicked: activeSearch }"
                            d="M19.4999 12.9689L15.8478 9.26949L15.7037 9.12353L15.5324 9.23632C14.7699 9.7384 13.8772 10.0359 12.9099 10.0359C10.291 10.0359 8.15991 7.88182 8.15991 5.22106C8.15991 2.56031 10.291 0.40625 12.9099 0.40625C15.5288 0.40625 17.6599 2.56031 17.6599 5.22106C17.6599 6.20322 17.3655 7.10846 16.8703 7.87049L16.7608 8.03896L16.9018 8.18212L20.5588 11.8963L19.4999 12.9689ZM5.65991 2.94514H1.15991V1.41921H5.65991V2.94514ZM1.15991 8.00995V6.48403H5.65991V8.00995H1.15991ZM16.1599 5.22106C16.1599 3.41465 14.701 1.93218 12.9099 1.93218C11.1188 1.93218 9.65991 3.41465 9.65991 5.22106C9.65991 7.02748 11.1188 8.50995 12.9099 8.50995C14.701 8.50995 16.1599 7.02748 16.1599 5.22106ZM10.6599 11.5488V13.0748H1.15991V11.5488H10.6599Z"
                            fill="#CECEDA"
                        />
                    </svg>
                </router-link>
            </div>
            <div class="icon2">
                <router-link :to="{ name: 'TournamentCalendar' }">
                    <svg width="17" height="18" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            :class="{ clicked: activeTour }"
                            d="M3.25 2V0.25H4.75V2V2.25H5H13H13.25V2V0.25H14.75V2V2.25H15H16C16.9619 2.25 17.75 3.03807 17.75 4V18C17.75 18.9619 16.9619 19.75 16 19.75H2C1.02892 19.75 0.25005 18.9628 0.25 18.0001C0.25 18.0001 0.25 18 0.25 18L0.26 4.00018V4C0.26 3.03561 1.03052 2.25 2 2.25H3H3.25V2ZM16 18.25H16.25V18V7V6.75H16H2H1.75V7V18V18.25H2H16ZM9.25 15.75V11.25H13.75V15.75H9.25Z"
                            fill="#CECEDA"
                            stroke-width="0.05"
                        />
                    </svg>
                </router-link>
            </div>
            <div class="icon">
                <router-link :to="{ name: 'OnlineUsers' }">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="30px"
                        viewBox="0 -960 960 960"
                        width="27px"
                        fill="#ceceda"
                    >
                        <path
                            :class="{ clicked: activeWallet }"
                            d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z"
                        />
                    </svg>
                    <!-- <svg
                        xmlns="http://www.w3.org/2000/svg"
                        :class="{ clicked: activeWallet }"
                        class="green-flame"
                        height="24px"
                        viewBox="0 -960 960 960"
                        fill="#CECEDA"
                        stroke="#CECEDA"
                    >
                        <path
                            d="M240-400q0 52 21 98.5t60 81.5q-1-5-1-9v-9q0-32 12-60t35-51l113-111 113 111q23 23 35 51t12 60v9q0 4-1 9 39-35 60-81.5t21-98.5q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62 0-107.5-41T401-690q-39 33-69 68.5t-50.5 72Q261-513 250.5-475T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm0-492v132q0 34 23.5 57t57.5 23q18 0 33.5-7.5T622-658l18-22q74 42 117 117t43 163q0 134-93 227T480-80q-134 0-227-93t-93-227q0-129 86.5-245T480-840Z"
                        />
                    </svg> -->
                    <!-- <svg
                        xmlns="http://www.w3.org/2000/svg"
                        
                        fill="#6F7381"
                        height="24px"
                        viewBox="0 -960 960 960"
                        width="24px"
                    >
                        <path
                            :class="{ clicked: activeWallet }"
                            fill="#6F7381"
                            d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z"
                        />
                    </svg> -->

                    <!-- <svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            :class="{ clicked: activeWallet }"
                            d="M3.04346 14.4492C2.21012 14.4492 1.50179 14.1576 0.918457 13.5742C0.335124 12.9909 0.043457 12.2826 0.043457 11.4492V3.44922C0.043457 2.61589 0.335124 1.90755 0.918457 1.32422C1.50179 0.740885 2.21012 0.449219 3.04346 0.449219H15.0435C15.8768 0.449219 16.5851 0.740885 17.1685 1.32422C17.7518 1.90755 18.0435 2.61589 18.0435 3.44922V11.4492C18.0435 12.2826 17.7518 12.9909 17.1685 13.5742C16.5851 14.1576 15.8768 14.4492 15.0435 14.4492H3.04346ZM3.04346 3.94922H15.0435C15.4435 3.94922 15.8101 4.01589 16.1435 4.14922C16.4768 4.28255 16.7768 4.48255 17.0435 4.74922V3.44922C17.0435 2.89922 16.8478 2.42855 16.4565 2.03722C16.0645 1.64522 15.5935 1.44922 15.0435 1.44922H3.04346C2.49346 1.44922 2.02279 1.64522 1.63146 2.03722C1.23946 2.42855 1.04346 2.89922 1.04346 3.44922V4.74922C1.31012 4.48255 1.61012 4.28255 1.94346 4.14922C2.27679 4.01589 2.64346 3.94922 3.04346 3.94922ZM1.06846 6.67422L12.4185 9.44922C12.5351 9.48255 12.6601 9.48255 12.7935 9.44922C12.9268 9.41588 13.0435 9.35755 13.1435 9.27422L16.8685 6.12422C16.7185 5.77422 16.4811 5.49089 16.1565 5.27422C15.8311 5.05755 15.4601 4.94922 15.0435 4.94922H3.04346C2.52679 4.94922 2.08512 5.11189 1.71846 5.43722C1.35179 5.76189 1.13512 6.17422 1.06846 6.67422Z"
                            fill="#6F7381"
                        />
                    </svg> -->
                </router-link>
            </div>
            <div v-if="$store.state.current_user.user_uuid">
                <router-link
                    :to="{
                        name: 'Profile',
                        params: { id: $store.state.current_user.user_uuid },
                    }"
                >
                    <img
                        id="profile-pic"
                        :src="
                            $store.state.current_user.profile.file_url ||
                            'https://outpostchess.fra1.digitaloceanspaces.com/2bf139b2-7074-4fd4-8377-58efead41bf0.png'
                        "
                        alt="profile-pic"
                    />
                </router-link>
            </div>
            <div v-else>
                <img
                    id="profile-pic"
                    :src="'https://outpostchess.fra1.digitaloceanspaces.com/2bf139b2-7074-4fd4-8377-58efead41bf0.png'"
                    alt="profile-pic"
                />
            </div>
        </div>
    </div>
</template>

<script>
//import socketUtil from "../../socket";
export default {
    name: "ChatInnerFooter",
    data() {
        return {
            user: { profile: [] },
            location: "",
            activeChatroom: false,
            activeSearch: false,
            activeProfile: false,
            activeWallet: false,
            activeTour: false,
            activeHome: false,
            unreadMessage: false,
            lista: [],
        };
    },
    watch: {
        "$store.state.unreadMessage"() {
            this.messageAlert();
        },
    },
    created() {
        //  socketUtil.subscribe("tb_notification", this.receiveMessageFooter);
        // if (localStorage.getItem("token")) {
        //     this.messageAlert();
        // }
    },
    mounted() {
        this.location = window.location.href.split("/").pop();
        if (this.location == "chatroom") {
            this.activeChatroom = true;
        }
        if (this.location == "intsearch") {
            this.activeSearch = true;
        }
        if (this.location == "profile") {
            this.activeProfile = true;
        }
        if (this.location == "online-list") {
            this.activeWallet = true;
        }
        if (this.location == "tournament-calendar") {
            this.activeTour = true;
        }
        if (this.location == "home-page") {
            this.activeHome = true;
        }
    },
    methods: {
        /*   receiveMessageFooter(payload) {

            if (payload.type == "MESSAGE" && payload.i_am_sender == false) {
                for (let i = 0; i < this.$store.state.message_info?.length; i++) {
                    if (
                        this.$store.state.message_info[i].conv_uuid == payload.conversation_uuid &&
                        this.$store.state.message_info[i]?.msg_id < payload?.msg_id
                    ) {
                        this.unreadMessage = true;
                    }
                }
            }
        },*/
        messageAlert() {
            this.unreadMessage = this.$store.state.unreadMessage;

            /*    for (this.i = 0; this.i < this.$store.state.message_info?.length; this.i++) {
                if (
                    this.$store.state.message_info[this.i].msg_id !=
                    this.$store.state.message_info[this.i].last_mgs_read_id
                ) {
                    this.unreadMessage = true;
                }
            }  */
        },
    },
};
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

p {
    color: #6f7381;
    font-weight: 500;
    font-size: 0.875rem;
    line-height: 1.158rem;
}

#message_notification {
    color: white;
    position: relative;
    bottom: 0.5rem;
    right: 0.3rem;
    border: 1px solid #11c6d1;
    border-radius: 50%;
    background-color: #11c6d1;
    height: 0.65rem;
    width: 0.65rem;
    z-index: 10;
}

/*path{
    fill:gray
}
.static {
        
        fill: gray;
      }

      .dynamic {
        fill: red;
      }
      */
.clicked {
    fill: #ffc695 !important;
}
.green-flame {
    fill: #42b983;
}
.clicked-home {
    stroke: #ffc695;
}
.icon {
    display: flex;
    align-items: center;
}
.icon2 {
    display: flex;
    align-items: center;
}
.icon:hover {
    opacity: 0.7;
}

#profile-pic {
    border-radius: 50%;
    height: 2.7rem;
    width: 2.7rem;
    object-fit: cover;
}
.footer {
    display: none;
}

@media screen and (max-width: 1440px) {
}

@media screen and (max-width: 640px) {
    .footer {
        height: 56px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0px 25px 0px 25px;
        background-color: #171819;
        border-top: 0.5px solid rgba(255, 255, 255, 0.2);
    }
}

@media screen and (max-width: 375px) {
}
</style>
